/* ===========================================================================
   The Golden Hopper — shared product-page library.

   This ships inside the DATA block, which is pasted once. Every design then
   uses it, so the cart path, the subscription maths and the free-shipping
   meter behave identically no matter which design is live — and each design
   block stays small enough for Shopify's 50KB limit on a Custom Liquid
   setting.

   Nothing here writes copy. Every string comes from GH_DATA.
   =========================================================================== */
window.GH = (function () {
  var S = window.GH_SHARED || {};

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function money(n) {
    return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '');
  }
  /* The Trio writes one line per coffee in several fields. HTML collapses newlines,
     so without this they run together into a single unreadable blob. */
  function lines(s) {
    return String(s == null ? '' : s).split('\n')
      .map(function (l) { return l.trim(); }).filter(Boolean);
  }
  function paras(s, cls) {
    return lines(s).map(function (l) {
      return '<p class="' + cls + '">' + esc(l) + '</p>';
    }).join('');
  }

  /* the live page knows which coffee it is from the URL; the preview forces one.

     There is no falling back to the first product when a real product URL does not
     match. It used to, and the consequence was ugly: anything not in this data file
     rendered as Honduras, with Honduras photos, Honduras copy and an add-to-cart that
     really did add Honduras. That covers the four unlisted products, which still
     answer on their own URLs, and every product Cain adds from now on until the data
     is regenerated. Returning null instead lets the section stand aside and let the
     theme's own product page do the work. Only a URL with no product in it at all,
     which means a preview harness, gets a default. */
  function pick() {
    var all = window.GH_COFFEE || [];
    var forced = window.GH_FORCE_HANDLE || '';
    var inUrl = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || '';
    var h = forced || inUrl;
    if (!h) return all[0] || null;
    return all.filter(function (p) { return p.handle === h; })[0] || null;
  }

  function img(src, w) {
    var u = (window.GH_DATA && GH_DATA.cdn ? GH_DATA.cdn : '') + src;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 900);
  }

  /* Options are whatever the product actually has in Shopify — Size and Grind on a bag,
     Size alone on the granola, Colour on the tumbler, none at all on the mug. Nothing
     here assumes a coffee. An option with a single value is not a choice, so it is not
     offered; the mug's "Title / Default Title" disappears entirely. */
  function choosable(p) {
    return (p.options || []).filter(function (o) { return (o.values || []).length > 1; });
  }
  /* Shopify puts ?variant=<id> on a product URL whenever a specific variant is the thing
     being linked to, and it is not a rare shape: it is what the theme's own share button
     emits, what the Google Shopping and Meta feeds carry, and what "buy it again" in an
     order confirmation points at. Opening such a link on 2lb ground and being shown 12oz
     at a different price is a broken promise, and the add button would have posted the
     12oz too. */
  function urlChoice(p) {
    var m = /[?&]variant=(\d+)/.exec(location.search || '');
    if (!m) return null;
    var want = String(m[1]);
    var v = (p.variants || []).filter(function (x) { return String(x.id) === want; })[0];
    if (!v || !v.opts) return null;
    var pick = {};
    (p.options || []).forEach(function (o) { pick[o.name] = v.opts[o.name]; });
    return pick;
  }
  function firstChoice(p) {
    /* an explicit variant in the URL beats every default, in stock or not: if somebody is
       sent to a sold-out variant the honest thing is to show it sold out */
    var fromUrl = urlChoice(p);
    if (fromUrl) return fromUrl;
    var pick = {};
    /* start on something that is actually in stock where possible */
    var live = (p.variants || []).filter(function (v) { return v.available; })[0]
            || (p.variants || [])[0];
    (p.options || []).forEach(function (o) {
      pick[o.name] = live && live.opts ? live.opts[o.name] : (o.values || [])[0];
    });
    return pick;
  }
  function variantFor(p, chosen) {
    return (p.variants || []).filter(function (v) {
      return (p.options || []).every(function (o) {
        return !chosen[o.name] || v.opts[o.name] === chosen[o.name];
      });
    })[0] || null;
  }
  /* what a value costs, given everything else the customer has already picked */
  function priceForValue(p, name, value, chosen) {
    var hit = (p.variants || []).filter(function (v) {
      if (v.opts[name] !== value) return false;
      return (p.options || []).every(function (o) {
        return o.name === name || !chosen[o.name] || v.opts[o.name] === chosen[o.name];
      });
    });
    if (!hit.length) {
      hit = (p.variants || []).filter(function (v) { return v.opts[name] === value; });
    }
    return hit.length ? Math.min.apply(null, hit.map(function (v) { return v.price; })) : null;
  }
  /* does any in-stock variant have this value, given the other choices */
  function liveWith(p, name, value, chosen) {
    return (p.variants || []).some(function (v) {
      if (!v.available || v.opts[name] !== value) return false;
      return (p.options || []).every(function (o) {
        return o.name === name || !chosen[o.name] || v.opts[o.name] === chosen[o.name];
      });
    });
  }
  /* a readable line for the chosen combination: "12oz, ground" / "Blue" / "" */
  function chosenLabel(p, chosen) {
    return (p.options || []).map(function (o) { return chosen[o.name]; })
      .filter(Boolean)
      .map(function (v, i) { return i === 0 ? v : String(v).toLowerCase(); })
      .join(', ');
  }

  /* Two separate subscription groups in Shopify, both called "Subscribe and save": the
     coffee one at 15/10/5% and the chocolates one at 10%. The Trio and the merch are in
     neither. */
  function plans(p) {
    var key = p && p.sub;
    var set = key && S.subscriptions && S.subscriptions[key];
    return set ? (set.plans || []) : [];
  }
  function subPrice(base, off) {
    return Math.round(base * (100 - off)) / 100;
  }

  /* What is already in the cart matters: telling somebody they are $16 from free
     shipping when they have $30 of coffee in the basket would simply be wrong.
     Shopify answers /cart.js on every storefront; anywhere it does not (the preview),
     this resolves to null.

     null and 0 are deliberately different answers. This used to return 0 on failure,
     which reads as "the cart is empty" — so a blocked request or a 5xx a second after a
     successful add made the meter announce "This order is $0" and reset its bar, right
     after the customer had put $43 in the basket. null means "not known", and every
     caller keeps whatever it had rather than believing the cart just emptied. */
  function cartTotal() {
    if (!window.fetch) return Promise.resolve(null);
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { return c && typeof c.total_price === 'number' ? c.total_price / 100 : null; })
      .catch(function () { return null; });
  }

  /* If the fetch above fails — offline, a blocked request, a Shopify hiccup — the
     customer must still be able to buy. This posts a real form to /cart/add, which
     leaves them on /cart rather than in the drawer, but it is a sale rather than a
     dead button. Only ever called after addToCart has rejected. */
  function postFallback(item) {
    var f = document.createElement('form');
    f.method = 'post';
    f.action = '/cart/add';
    f.style.display = 'none';
    function add(name, value) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = name; i.value = String(value);
      f.appendChild(i);
    }
    add('id', item.id);
    add('quantity', item.quantity || 1);
    if (item.sellingPlan) add('selling_plan', item.sellingPlan);
    /* the Special Requests note is a line item property, and it was being dropped here:
       the customer typed "please grind for a Chemex", the bag went in the cart, and the
       request quietly did not. Shopify reads properties off a form post under this name. */
    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        if (item.properties[k] !== '' && item.properties[k] != null) {
          add('properties[' + k + ']', item.properties[k]);
        }
      });
    }
    document.body.appendChild(f);
    f.submit();
  }

  /* The shop's cart drawer watches window.fetch and XMLHttpRequest for /cart/add and
     refreshes itself. A plain form POST is neither, so it would bypass the drawer and
     dump the customer on /cart. Going through fetch keeps them here. */
  function addToCart(item) {
    var line = { id: Number(item.id), quantity: item.quantity || 1 };
    if (item.sellingPlan) line.selling_plan = Number(item.sellingPlan);
    if (item.properties) line.properties = item.properties;
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [line] })
    }).then(function (res) {
      if (!res.ok) throw new Error('add failed');
      return res.json();
    }).then(function (r) {
      var drawer = document.getElementById('ship-cart');
      if (drawer) setTimeout(function () { drawer.click(); }, 420);
      return r;
    });
  }

  /* "Learn about this roast" — the same six panels, in the same order, as the live
     product page. Panel two is shop-wide copy; the rest are this product's metafields.
     A mug has none of them, so this returns nothing and the section is not rendered. */
  function roastPanels(p) {
    if (!p || p.kind !== 'coffee') return [];
    return [
      ['Tasting Notes',        p.tastingNotes],
      ['Whole Bean Or Ground', S.wholeBeanOrGround],
      ['Origin Story',         p.originStory],
      ['Processing Method',    p.grind],
      ['Elevation',            p.elevation],
      ['Harvest Season',       p.harvest]
    ].filter(function (r) { return r[1]; });
  }

  /* The free-shipping meter.

     It reports what is IN THE CART, because that is what the shop's own free-shipping
     bar reports, and two indicators on one page disagreeing is worse than no indicator.
     An earlier version counted the item being looked at as though it were already added,
     so choosing a $43 bag announced "shipping is free" with an empty cart. That was
     simply untrue - nothing had been added - and it contradicted the bar at the top of
     the page.

     What the current selection WOULD do is reported separately, as a projection:
     thisQualifies when adding it crosses the line, offerMore when another one would. */
  function meterState(cart, unit, qty) {
    var at = S.freeShippingAt || 35;
    cart = cart || 0; unit = unit || 0; qty = qty || 1;
    var shortBy = Math.round((at - cart) * 100) / 100;
    var free = shortBy <= 0;
    var withThis = cart + unit * qty;
    var need = unit > 0 ? Math.ceil((at - cart) / unit) : 0;
    return {
      free: free,
      shortBy: shortBy,
      pct: Math.max(0, Math.min(100, cart / at * 100)),
      text: free
        ? 'Shipping is free on this order.'
        : 'You are ' + money(shortBy) + ' from free shipping.',
      /* adding what is selected would cross the line on its own */
      thisQualifies: !free && unit > 0 && withThis >= at,
      /* one more of it would, and asking for more than ten is not a nudge */
      offerMore: !free && unit > 0 && withThis < at && need > qty && need <= 10,
      needQty: need
    };
  }

  /* Designs run at the bottom of the section, but a Custom Liquid block can be placed
     above the data block. Rather than depend on paste order, wait for the data. */
  function ready(fn) {
    if (window.GH_COFFEE && window.GH_COFFEE.length) return fn();
    var tries = 0;
    var t = setInterval(function () {
      if (window.GH_COFFEE && window.GH_COFFEE.length) { clearInterval(t); fn(); }
      else if (++tries > 60) { clearInterval(t); }
    }, 50);
  }

  /* ---------- press feedback ----------
     Shared because every design shows the same controls and the same three badges, and
     because both of these have to dodge the same trap: each design opens with a reset
     that pins `transform:none !important` on its own subtree, and an !important author
     rule outranks a keyframe. Each reset exempts `.<prefix>-alt`, so anything that
     animates a transform wears that class for as long as it is moving.

     Callers pass their own prefix — GH.ripple(el, ev, 'p1') — so nothing here has to
     know which design it is decorating. */
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion:reduce)')
                             : { matches: false };

  /* a ripple from the point actually pressed, so the control answers where it was
     touched instead of lighting up as a whole. pointerdown is one path for finger
     and mouse alike. */
  function ripple(host, ev, pfx) {
    if (RM.matches || !host || typeof ev.clientX !== 'number') return;
    var r = host.getBoundingClientRect();
    if (!r.width) return;
    var d = Math.max(r.width, r.height) * 2.2;
    var s = document.createElement('span');
    s.className = pfx + '-rip ' + pfx + '-alt';
    s.style.width = s.style.height = d + 'px';
    s.style.left = (ev.clientX - r.left - d / 2) + 'px';
    s.style.top  = (ev.clientY - r.top  - d / 2) + 'px';
    host.appendChild(s);
    var gone = function () { if (s.parentNode) s.parentNode.removeChild(s); };
    s.addEventListener('animationend', gone);
    /* animationend never arrives on a backgrounded tab, and ripples must not pile up */
    setTimeout(gone, 1200);
  }

  /* the settle on whichever control just became the selected one */
  function pop(el, pfx) {
    if (RM.matches || !el) return;
    el.classList.remove('is-pop', pfx + '-alt');
    void el.offsetWidth;                      /* restart it if it is already running */
    el.classList.add(pfx + '-alt', 'is-pop');
    var done = function () {
      el.classList.remove('is-pop', pfx + '-alt');
      el.removeEventListener('animationend', done);
    };
    el.addEventListener('animationend', done);
    setTimeout(done, 900);
  }

  /* ---------- the trust badges ----------
     The shop's three lines arrive with an emoji on the front. The words are its own and
     never change; the emoji is dropped for a drawn icon so the strip stops looking like
     the stock badge row every Shopify store ships. The icon is picked off the words, so
     a reworded badge still gets the right one — and "Free Shipping" has to be tested
     before "Ships in", or both land on the parcel. */
  var BSVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"' +
             ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">';
  var BICON = {
    seal: BSVG + '<circle cx="12" cy="9.1" r="6.1"/><path d="m9.4 9 1.9 1.9 3.4-3.6"/>' +
          '<path d="M8.7 14.3 7.3 21l4.7-2.4L16.7 21l-1.4-6.7"/></svg>',
    box:  BSVG + '<path d="M3.5 7.7 12 3.3l8.5 4.4v8.6L12 20.7l-8.5-4.4z"/>' +
          '<path d="M3.5 7.7 12 12.1l8.5-4.4M12 12.1v8.6M7.75 5.5l8.5 4.4"/></svg>',
    time: BSVG + '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.2V12l3.2 1.9"/></svg>'
  };
  function badge(raw) {
    var t = String(raw == null ? '' : raw).replace(/^[^A-Za-z0-9$]+/, '').trim();
    var k = /shipping|deliver|free\s*\$?\d/i.test(t) ? 'box'
          : /satisf|guarant|quality|love/i.test(t)   ? 'seal'
          : /ship|day|hour|week|roast/i.test(t)      ? 'time'
          : 'seal';
    return { t: t, svg: BICON[k] };
  }

  return {
    ripple: ripple, pop: pop, badge: badge, reducedMotion: RM,
    esc: esc, money: money, lines: lines, paras: paras,
    pick: pick, img: img,
    choosable: choosable, firstChoice: firstChoice, variantFor: variantFor,
    priceForValue: priceForValue, liveWith: liveWith, chosenLabel: chosenLabel,
    plans: plans, subPrice: subPrice,
    cartTotal: cartTotal, addToCart: addToCart, postFallback: postFallback,
    roastPanels: roastPanels, meterState: meterState, ready: ready,
    shared: S
  };
})();
